<div class="container" style="margin-top: 20px">
  <h1 class="orga-data-tile">Coordonnées bancaires</h1>
  <div>Vos informations bancaires sont nécessaires pour la sécurité de vos paiements et le transfert  de vos fonds.</div>

  <div class="col-md-10" style="margin-left: auto;margin-right: auto;margin-top: 50px">
    <h4 class="document-title">RIB/IBAN</h4>

    <div *ngIf="ribBlocIsVisible('ribPassword')">
      <div class="center mt-30">Pour sécuriser vos coordonnées bancaires ,merci de bien vouloir renseigner votre mot de passe associé au compte Akces.</div>
      <div class="center mt-30">
        <div class="danger incorect-password_label" *ngIf="incorrectPasswordError">Mot de passe incorrect</div>
        <div class="incorect-password_label" *ngIf="loadingUnlockPassword">Chargement ...</div>
        <div class="input-group mb-3 col-md-9 m-auto">
          <input type="password" [(ngModel)]="passwordEmail.password" name="password" class="form-control" placeholder="Votre mot de passe">
          <div class="input-group-append">
            <button class="input-group-text passwd-next_btn" [disabled]="loadingUnlockPassword" id="basic-addon2" (click)="unlockWithPassWord()">suivant</button>
          </div>
        </div>
        <div class="mt-8p pointer">Mot de passe oublié?</div>
      </div>
    </div>

    <div *ngIf="ribBlocIsVisible('noRibAddRib')">
      <div>
        <div class="center mt-30p mb-30p"> il n'ya aucun moyen de paiement enrégistré actuellement. </div>
        <div class="center m-auto col-md-7 add-rib-btn" (click)="goToRibBlocItem('ribForm')">
          <div><i class="fa fa-plus-circle fs-40p" aria-hidden="true"></i></div>
          <div class="fs-21p">Ajouter votre rib</div>
        </div>
      </div>
    </div>

    <div *ngIf="ribBlocIsVisible('ribList')">
      <div class="mt-45p">
        <div class="col-md-8 m-auto rib-box flex-column">
          <div class="flex-space-between">
            <div class="rib-name">{{payment.Titulaire}}</div>
            <div *ngIf="payment.validatedByAdmin" class="rib-validated-label">Enrégistré</div>
            <div *ngIf="!payment.validatedByAdmin" class="rib-unvalidated-label"></div>
          </div>
          <div class="mt-15p">
            <div>{{displayBic(payment.bic)}}</div>
            <div>{{displayIban(payment.iban)}}</div>
          </div>
        </div>
      </div>
      <div class="center mt-30p">
        <button class="edit-rib_btn" (click)="editRib()">modifier rib/iban</button>
      </div>
    </div>

    <div *ngIf="ribBlocIsVisible('ribForm')">
      <form (ngSubmit)="onRibSubmit(ribForm.valid)" #ribForm="ngForm" style="margin-top: 50px">
       <!-- <div class="document-subtitle mt-10p">Coordonnées bancaires</div>-->
        <div class="col-md-12 form-group">
          <label for="domiciliation">Domiciliation</label>
          <input type="text" [(ngModel)]="payment.domiciliation" name="domiciliation" required id="domiciliation"  class="form-control">
          <div class="form-control-feedback alert alert-danger custom-alert-danger">
            Le prénom de la cagnotte est requis
          </div>
        </div>
        <div class="row col-md-12">
          <div class="col-md-6 form-group form-group-required" [ngClass]="{'has-danger': paymentIban.errors && (paymentIban.dirty || paymentIban.touched || payementErrors.length)}">
            <label for="iban">IBAN</label>
            <input type="text" [(ngModel)]="payment.iban" id="iban" name="iban" #paymentIban="ngModel" required class="form-control">
            <div class="form-control-feedback alert alert-danger custom-alert-danger">
              L'iban est requis
            </div>
          </div>
          <div class="col-md-6 form-group form-group-required" [ngClass]="{'has-danger': paymentbic.errors && (paymentbic.dirty || paymentbic.touched || payementErrors.length)}">
            <label for="bic">BIC</label>
            <input type="text" [(ngModel)]="payment.bic" id="bic" required name="bic" #paymentbic="ngModel" class="form-control">
            <div class="form-control-feedback alert alert-danger custom-alert-danger">
              Le bic est requis
            </div>
          </div>
        </div>
        <div class="col-md-12 form-group form-group-required" [ngClass]="{'has-danger': paymentTitulaire.errors && (paymentTitulaire.dirty || paymentTitulaire.touched || payementErrors.length)}">
          <label for="account_owner">Propriétaire du compte</label>
          <input type="text" [(ngModel)]="payment.Titulaire" id="account_owner" name="account_owner" #paymentTitulaire="ngModel" required class="form-control">
          <div class="form-control-feedback alert alert-danger custom-alert-danger">
            Le nom du propriétaire est requis
          </div>
        </div>
        <div class="col-md-12 form-group">
          <label for="download_iban">Téléchargez votre IBAN ou RIB au format PDF</label>
          <div class="download-iban-file center" (click)="openDownloadIban()">
            <span *ngIf="payment.rib_iban_pdf">Chargé</span>
          </div>
          <input style="display: none" (change)="iban_bic_download_FileListenner($event)" type="file" id="download_iban" class="form-control">
        </div>

        <div class="center form-group col-md-12 mt-30p">
          <button (click)="createOrUpdatePayment($event)" class="save-document-btn" *ngIf="!payment.id">enrégistrer iban/iban</button>
          <button (click)="createOrUpdatePayment($event)" class="save-document-btn" *ngIf="payment.id">modifier iban/iban</button>
        </div>
      </form>
    </div>
  </div>

</div>
